exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-search[data-v-4ec8446c]{border:none;border-radius:4px!important;padding:4px 12px;background:#2f23d6;transition:.2s}.button-search[data-v-4ec8446c]:active,.button-search[data-v-4ec8446c]:hover{background:#1d12b9}.button-search>.button-validate>.button-label[data-v-4ec8446c]{font-weight:400;font-size:13px;line-height:140%;color:#fff}.button-search>.button-validate>.button-loading>.button-spinner>div[data-v-4ec8446c]{margin-right:1.8px!important;height:20px!important}.button-search>.button-validate>.button-loading>.button-spinner .rect5[data-v-4ec8446c]{margin-right:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4ec8446c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/components/buttons/btnBlue.vue
// module id = 869
// module chunks = 0